/**
 * Global Utilities - Show/Hide Elements Based on Conditions
 */

export function initGlobal() {
    
    // Get current page information
    const body = document.body;
    const isHomePage = body.classList.contains('home') || body.classList.contains('page-template-tpl-home');
    const isContactPage = body.classList.contains('page-template-tpl-contact');
    
    // Contact form wrapper visibility
    const contactFormWrapper = document.querySelector('footer .contact-form-wrapper');
    const contactHeader= document.querySelector('.header-contact');
    if ( isContactPage) {
        contactFormWrapper.style.display = 'none';
        contactHeader.style.display = 'none';
    }
    
    // Contact info visibility based on page
    const contactInfo = document.querySelector('.contact-info');
    if (contactInfo) {
        if (isHomePage) {
            // On home: hidden on small screens, visible on 2xl
            contactInfo.classList.add('hidden', '2xl:flex');
        }else if (isContactPage) {
            // On contact page: always visible
            contactInfo.classList.remove('hidden');
            contactInfo.classList.add('flex');
        } 
        else {
            // On other pages: always visible
            contactInfo.classList.add('hidden','lg:flex');
        } 
    }
    
    // Footer padding adjustments
    const footerLinks = document.querySelector('.footer-links');

    if (contactFormWrapper) {
        if (isHomePage) {
            // Only add pl-[420px] on screens >= 1024px
            contactFormWrapper.classList.add('lg:pl-[420px]');
        } else {
            contactFormWrapper.classList.add('lg:pl-32');
        }
    }
    
    if (footerLinks) {
        if (isHomePage) {
            footerLinks.classList.add('lg:pl-[420px]');
        } else {
            footerLinks.classList.add('lg:pl-32');
        }
    }
    
    // Add more conditional show/hide logic here as needed
}